import { Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchManagers } from "../api/managerApi";

const ManagerSelect = ({
  name = "manager_id",
  clearable = false,
  label,
  validationMessage,
  initialValue,
  value,
  required,
  readOnly,
  showSearch = false,
  onChange = null,
  sendOnchange = null,
  placeholder = null,
  activeOnly = false,
  mode="single",
  hideLabel  = false,
  withFormItem = true,
}) => {
  const { t } = useTranslation();

  const [managers, setManagers] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value ?? initialValue ?? null);

  useEffect(() => {
    const loadManagers = async () => {
      const sortedManagers = await fetchManagers(activeOnly);
      setManagers(sortedManagers);
    };

    loadManagers();
  }, [activeOnly]);


  useEffect(() => {
    setSelectedValue(value ?? initialValue ?? null);
  }, [initialValue, value]);

  const selectNode = (
    <Select
      mode={mode}
      value={selectedValue ?? undefined}
      onChange={(nextValue, option) => {
        if (value === undefined) {
          setSelectedValue(nextValue);
        }

        onChange?.(nextValue, option);

        if (sendOnchange) {
          sendOnchange(nextValue, option);
        }
      }}
      allowClear={clearable}
      disabled={readOnly}
      bordered={!readOnly}
      showSearch={showSearch}
      placeholder={placeholder || t("managers.selectManager")}
      optionFilterProp="searchLabel"
      filterOption={(input, option) =>
        typeof option?.searchLabel === "string" &&
        option.searchLabel.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {managers.map((manager) => {
        const fullName = `${manager.first_name} ${manager.last_name}`;

        return (
          <Select.Option
            key={manager.id}
            value={manager.id}
            data-user-id={manager?.user?.id || null}
            searchLabel={fullName}
          >
            {manager?.user?.deleted_at === null ? (
              fullName
            ) : (
              <s>{fullName}</s>
            )}
          </Select.Option>
        );
      })}
    </Select>
  );

  if (!withFormItem) {
    return selectNode;
  }

  return (
    <Form.Item
      name={name}
      label={hideLabel ? undefined :label}
      rules={[
        {
          required: required,
          message: validationMessage,
        },
      ]}
      initialValue={selectedValue}
      style={hideLabel ? {width: 'auto'} :{minWidth: '240px'}}
    >
      {selectNode}
    </Form.Item>
  );
};

export default ManagerSelect;
